import Component from '../Component';
import Logo from '../../../images/Mapka_logo_NEGATIV.svg';
import Subtitle from '../../../images/Mapka_pouze_text_2_radky_NEGATIV.svg';

class Header extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.setupEventListeners();
	}

	setupEventListeners() {
		this.refs['close'].addEventListener(
			'click', () => {
				this.props.handleClose();
				this.dispatchCustomEvent('close-layer-control', this.refs['close']);
			}
		);
	}

	render() {
		return `
            <div class="layerPanel__header">
                <img src="${Logo}" alt="Mapka" style="height: 2.8em">
                <img src="${Subtitle}" alt="Mapová aplikace pro korpusy mluvené češtiny" style="height: 2.8em">
                <span ref="close" class="close js-close" aria-label="Close" style="margin-left: auto">
                    <i class="fas fa-times"></i>
                </span>
            </div>`;
	}
}

export default Header;
